module.exports = __webpack_public_path__ + "img/mini-check.091638e4.svg";